import React from 'react'
import { graphql, Link } from 'gatsby'
import truncate from 'truncate-html'
import Breadcrumb from '../components/Breadcrumb'
import HTMLContent from '../components/Content'

import Layout from '../components/Layout'
import BgImage from '../components/BgImage'
import PorteaServices from '../components/PorteaServices'
import SEO from '../components/Seo'

export default function PatientStories({ data }){
  const { topbanner, allWpPatientStory: stories } = data

  const breadcrumbs = [
    { target: '/', display: 'Home', keep: true },
    { target: '/patient-stories/', display: 'Patient Stories' },
  ]

  return (
    <Layout>
      <SEO
        title="Portea Medical - Patient Stories"
        description="Healthcare at Home - Portea.com. Stories of recovery from our patients."
        url="/patient-stories/"
        breadcrumbs={breadcrumbs}
      />

      <section className="hero top-banner">
        <BgImage alt="banner" image={topbanner.childImageSharp.gatsbyImageData} height="100%" />
      </section>
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <section className="inner-title">
        <div className="container">
          <div className="columns">
            <div className="column is-12 has-text-centered">
              <p className="page-title">Patient Experiences</p>
            </div>
          </div>
        </div>
      </section>
      <section className="inner-page">
        <div className="container">
          <div className="columns is-multiline">
            <div className="column is-8">
              {stories.edges.map(({node}) => (
                <div className="box is-radiusless stories-cntr" key={node.title}>
                  <h3>
                    {node.title}
                  </h3>
                  <div className="stories-info f-16">
                    <i className="icon critical-care" />
                    {node.serviceType.category}
                    <span className="has-text-right">{node.patientDetails.city}</span>
                  </div>
                  <HTMLContent className="f-14" content={truncate(node.content, 400)} />

                  <Link to={node.fields.location} className="button btn-primary">
                    Read Full Story
                  </Link>
                </div>
              ))}
            </div>
            <div className="column is-4 right-panel">
              <PorteaServices />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export const pageQuery = graphql`query patientStoriesQuery {
  allWpPatientStory {
    edges {
      node {
        serviceType {
          service
          category
        }
        patientDetails {
          city
        }
        fields {
          location
        }
        content
        title
      }
    }
  }
  topbanner: file(relativePath: {eq: "banners/banner_patient_experiences.jpg"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
}`
